/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/oil'
export default icon
